
import { useState } from 'react';

const useItemSelection = (initialItems = []) => {
    const [selectedItems, setSelectedItems] = useState(initialItems);

    const isItemSelected = (item) => selectedItems.some(selectedItemId => selectedItemId === item.id);

    const toggleSelectItem = (item) => {
        if (isItemSelected(item)) {
            setSelectedItems(selectedItems.filter(selectedItemId => selectedItemId !== item.id));
        } else {
            setSelectedItems([...selectedItems, item.id]);
        }
    };

    return {
        selectedItems,
        isItemSelected,
        toggleSelectItem
    };
};

export default useItemSelection;
